<template>
    <div>
      <base-navigation></base-navigation>
   
    <div class="container">
      <h4>HVOCK contributions platform </h4>
      <p class="message">{{ message }}</p>
      <br>
      <br>
      <div class="table-container">
        <table>
          <tbody>
            <tr v-for="(item, index) in collections" :key="item.id">
              <td>{{ index + 1 }} </td>
             
              <td>{{ item.display_names }}</td>
              <td>{{ formatCurrency(item.TransAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="total-container">
        <br>
        List autopopulates after paying
        <br> 
        <strong>Total: {{ formatCurrency(totalAmount) }}</strong>
      </div>
      <button @click="copyTableData" class="copy-button">Copy Data</button>
    </div>
  </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    name: "CollectionsTable",
    data() {
      return {
        // message:          "Thank you famil for trusting the platform to support our members. Currenlty there no campaign going on.",

        message:          "Charity drive by HVOCK Club to support Destiny Children's Home - Kayole, Nairobi.. Make payments to Roberms collection paybill 4112827, Account 50549#YourNames(As you want to appear in collection list)",
      };
    },
    computed: {
      ...mapGetters(["collections"]),
      totalAmount() {
        return this.collections.reduce(
          (total, item) => total + item.TransAmount,
          0
        );
      },
      collections() {
        return  this.$store.getters.collections.filter(code=>code.clinet_code =='50549').filter(pr=>pr.processed !=1 )
       
      },
    },
    methods: {
      formatCurrency(amount) {
        return new Intl.NumberFormat("en-KE", {
          style: "currency",
          currency: "KES",
          minimumFractionDigits: 0,
        }).format(amount);
      },
      copyTableData() {
        const rows = [
      [this.message],
      [" "], 
      ...this.collections.map((item, index) => [
        `${index + 1}. ${item.display_names} - ${item.TransAmount}` 
      ]),
      [`*Total: ${this.formatCurrency(this.totalAmount)}*`], 
    ];
  
    const tableText = rows.map((row) => row.join("   ")).join("\n"); 
    navigator.clipboard
          .writeText(tableText)
          .then(() => {
            alert(" data copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy table data: ", err);
          });
      },
    },
    created() {
      this.$store.dispatch('LoadCollections');  
      
      
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 600px;
    margin: 20px auto;
    padding: 15px;
    font-family: Arial, sans-serif;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: #fff;
  }
  
  h2 {
    text-align: center;
    color: #007bff;
    font-size: 1.8rem;
  }
  
  .message {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    text-align: center;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    text-align: center;
  }
  
  td {
    padding: 12px;
    text-align: center;
    border: 1px solid #ddd;
    font-size: 0.9rem;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #f1f1f1;
  }
  
  .total-container {
    margin-top: 15px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  .copy-button {
    display: block;
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .copy-button:hover {
    background-color: #0056b3;
  }
  
  /* Responsive Design */
  @media (max-width: 600px) {
    h2 {
      font-size: 1.5rem;
    }
    .message {
      font-size: 0.9rem;
    }
    table td {
      font-size: 0.8rem;
    }
    .copy-button {
      font-size: 0.9rem;
    }
  }
  </style>
  
